import * as React from "react";
import DebtWidget from "./DebtWidget";
import { connect } from "react-redux";
import { defaultYear } from "src/constants/ApiSettings";
import { IConnectedModuleProps, IConnectedModuleState } from "src/interfaces";
import Loading from "src/components/general/Loading";
import SectionHeading from "src/components/general/SectionHeading";

class CouncilDebt extends React.PureComponent<
  IConnectedModuleProps,
  IConnectedModuleState
> {
  constructor(props: IConnectedModuleProps) {
    super(props);

    const selectedYear = defaultYear;

    this.state = { selectedYear };
  }

  public handleYearChange = (value: string) => {
    this.setState({ selectedYear: value });
  };

  public render() {
    const selectedCouncils = this.props.councils;
    return (
      <div className="flex flex-row flex-wrap flex-row-reverse w-full lg:mb-32" id="debt">
        <div className="w-full lg:w-1/2 flex flex-col lg:text-right">
          <SectionHeading
            heading="This is your council's debt"
            alignment="right"
            yearPicker={ this.handleYearChange }
            year={ this.state.selectedYear }
            learnMore={ "grossDebt" }
            councilSays={ "grossDebtCouncilSays" }
            inverse={ false }
          />
          <p className="my-4">
            Moderate levels of debt can be used by councils for productive
            purposes, but must be balanced against the benefit to the community.
          </p>
        </div>
        <div className="w-full lg:w-1/2 flex flex-wrap flex-row">
          {selectedCouncils.map((council, index) => {
            if (!council) {
              return <Loading />;
            }

            return (
              <DebtWidget
                key={index}
                year={this.state.selectedYear}
                ordinal={index + 1}
                name={council.name}
                council={council}
              />
            );
          })}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state: any) => ({
  defaultYear:
    state.selectables.years.length > 0 ? state.selectables.years[0] : null,
  councils: state.selected.councils,
  
});

const mapDispatchToProps = () => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CouncilDebt);



// WEBPACK FOOTER //
// ./src/components/report/councilFinances/CouncilDebt.tsx